import { FC } from 'react';
import classnames from 'classnames';

import { FormattedMessage } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button';
import { Spinner } from 'dibs-elements/exports/Spinner';

import styles from './styles/IFramedPromoPartnershipPCForm.scss';
import sharedStyles from '../styles/shared.scss';

type Props = {
    isLoading?: boolean;
    showError?: boolean;
};

const SubmitButton: FC<Props> = ({ isLoading, showError }) => {
    return (
        <div className={styles.submitButtonWrapper}>
            <Button
                dataTn="promo-partnership-private-client-form-submit-button"
                fullWidth
                disabled={isLoading}
                htmlType="submit"
                type="primary"
                className={classnames(sharedStyles.button, styles.submitButton)}
            >
                <FormattedMessage
                    id="iFramedpromoPartnership.PromoPartnershipPrivateClientForm.submit"
                    defaultMessage="Submit"
                />
                {isLoading && <Spinner containerClass={styles.spinner} size="tiny" />}
            </Button>
            {showError && (
                <div data-tn="service-error-message" className={styles.errorMessage}>
                    <FormattedMessage
                        id="iFramedpromoPartnership.PromoPartnershipPrivateClientForm.serviceError"
                        defaultMessage="Something went wrong. Please try again later."
                    />
                </div>
            )}
        </div>
    );
};

export default SubmitButton;
